import { render, staticRenderFns } from "./CreatedMind.vue?vue&type=template&id=452ff9a8&scoped=true&"
import script from "./CreatedMind.vue?vue&type=script&lang=js&"
export * from "./CreatedMind.vue?vue&type=script&lang=js&"
import style0 from "./CreatedMind.vue?vue&type=style&index=0&id=452ff9a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452ff9a8",
  null
  
)

export default component.exports